import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import NavBarElementMobile from './NavBarElementMobile';

export default function NavBarMobile({ handleClick, showMenu, setShowMenu }) {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    window.onscroll = () => setOffset(window.pageYOffset);
  }, []);

  return (
    <>
      {/* Mobile Navbar Button */}
      <div
        className={`md:hidden w-fit fixed p-4 flex items-center justify-between z-40 
          transition-all duration-300 ${
            offset > 0 ? 'bg-black' : 'bg-transparent'
          }`}
      >
        <button onClick={() => setShowMenu(true)}>
          <FontAwesomeIcon
            icon={faBars}
            className='h-8 text-white cursor-pointer'
          />
        </button>
      </div>

      {/* Mobile Menu (Full-Screen Overlay) */}
      {showMenu && (
        <div className='fixed inset-0 bg-black bg-opacity-95 z-50 flex flex-col items-start pt-12 px-4 text-white transition-opacity duration-300 ease-in-out w-full'>
          {/* Close Button */}
          <button
            className='absolute top-6 right-4 text-yellow-500 hover:text-yellow-400 transition-transform duration-300'
            onClick={() => setShowMenu(false)}
          >
            <FontAwesomeIcon icon={faXmark} className='h-10' />
          </button>

          {/* Menu Items */}
          <ul className='text-3xl font-semibold w-full'>
            <NavBarElementMobile
              text={'Почетна'}
              path='/home'
              id='home'
              handleClick={handleClick}
              setShowMenu={setShowMenu}
            />
            <NavBarElementMobile
              text={'Пива'}
              path='#'
              id='beers'
              handleClick={handleClick}
              setShowMenu={setShowMenu}
            />
            <NavBarElementMobile
              text={'Наша Прича'}
              path='#'
              id='our-story'
              handleClick={handleClick}
              setShowMenu={setShowMenu}
            />
            <NavBarElementMobile
              text={'Продавница'}
              path='#'
              id='locations'
              handleClick={handleClick}
              setShowMenu={setShowMenu}
            />
          </ul>
        </div>
      )}
    </>
  );
}
